import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedNumber } from 'react-intl'
import { FormattedDate } from 'components/intl'
import { Modal, LocaleSwitch } from 'containers/misc'
import { Button } from 'components/misc'

export default class Example extends Component {
  static propTypes = {
    notification: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired
  }

  render() {
    return (
      <div>
        <h2>Locale</h2>
        <div>
          <LocaleSwitch />
        </div>
        <div>
          <FormattedNumber value={10} format="currency" />
        </div>
        <div>
          <FormattedDate value={new Date()} />
        </div>
        <div>
          <FormattedDate value={new Date()} format="long" />
        </div>
        <h2>Redux actions</h2>
        <Button
          type="button"
          className="btn-success"
          onClick={() => this.props.notification('Success message', 'success')}
        >
          Success
        </Button>
        <br />
        <Button
          type="button"
          className="btn-success"
          onClick={() => this.props.modal('testModal')}
          secondary
        >
          Open Modal
        </Button>
        <Modal id="testModal">
          Modal content
        </Modal>
      </div>
    )
  }
}
